import { DateTime } from 'luxon';

export const formatMoney = (value: number | undefined | null): string => {
  if (value == null || isNaN(value)) return '—';
  const absolute = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (absolute >= 1e12) return `${sign}$${(absolute / 1e12).toFixed(2)}T`;
  if (absolute >= 1e9) return `${sign}$${(absolute / 1e9).toFixed(2)}B`;
  if (absolute >= 1e6) return `${sign}$${(absolute / 1e6).toFixed(1)}M`;
  return `${sign}$${absolute.toFixed(0)}`;
};

export const formatMoneyShort = (value: number | undefined | null): string => {
  if (value == null || isNaN(value) || value === 0) return '—';
  const absolute = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (absolute >= 1e12) return `${sign}$${(absolute / 1e12).toFixed(2)}T`;
  if (absolute >= 1e9) return `${sign}$${(absolute / 1e9).toFixed(1)}B`;
  if (absolute >= 1e6) return `${sign}$${(absolute / 1e6).toFixed(1)}M`;
  return `${sign}$${absolute.toFixed(0)}`;
};

export const formatTradeValue = (value: number): string => {
  const absolute = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  if (absolute >= 1e9) return `${sign}$${(absolute / 1e9).toFixed(1)}B`;
  if (absolute >= 1e6) return `${sign}$${(absolute / 1e6).toFixed(1)}M`;
  if (absolute >= 1e3) return `${sign}$${(absolute / 1e3).toFixed(0)}K`;
  return `${sign}$${absolute.toFixed(0)}`;
};

export const formatPercent = (value: number | undefined | null): string => {
  if (value == null || isNaN(value)) return '—';
  return `${value.toFixed(1)}%`;
};

export const formatRatioAsPercent = (value: number | undefined | null): string => {
  if (value == null || isNaN(value)) return '—';
  return `${(value * 100).toFixed(1)}%`;
};

export const formatDate = (date?: string | null): string => {
  if (!date) return '—';
  const parsed = DateTime.fromISO(date);
  return parsed.isValid ? parsed.toFormat('MMM d, yyyy') : '—';
};

export const formatCount = (value?: string | number | null): string => {
  if (value == null || value === '') return '—';
  const numeric = Number(value);
  return Number.isNaN(numeric) ? '—' : numeric.toLocaleString('en');
};

export const percentChange = (current: number, previous: number): number | null => {
  if (!previous) return null;
  return ((current - previous) / Math.abs(previous)) * 100;
};

export const isoToMillis = (date: string | null | undefined): number => {
  if (!date) return 0;
  const millis = DateTime.fromISO(date).toMillis();
  return Number.isNaN(millis) ? 0 : millis;
};

export const formatUpsidePercent = (
  priceTarget: string | number | null | undefined,
  price: number | null,
): string | null => {
  if (!priceTarget || !price || price === 0) return null;
  const percent = ((Number(priceTarget) - price) / price) * 100;
  return `${percent >= 0 ? '+' : ''}${percent.toFixed(1)}%`;
};
